import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminUsers = lazy(() => import("@/pages/admin/AdminUsers"));

export const Route = createFileRoute("/admin/administratorer")({
  head: () => ({
    meta: [
      { title: "Administratörer » Elmarknad.se" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => <AdminUsers adminsOnly />,
});
